module.exports = __webpack_public_path__ + "img/jason-pro.f49b1c86.jpg";